export default __webpack_public_path__ + "static/hero-desktop-c7496635590b31e4c7a8dc174cfac60b.png";